import { SET_SIDEBAR_VISIBILITY } from './action-types';

export function showSideBar() {
  return { type: SET_SIDEBAR_VISIBILITY, sideBarIsVisible: true };
}

export function hideSideBar() {
  return { type: SET_SIDEBAR_VISIBILITY, sideBarIsVisible: false };
}
